import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { ProShip_ModuleContextService } from './ProShip.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ProShip_proship_home_ComponentContextService {
  private readonly moduleContext: ProShip_ModuleContextService;

  constructor(moduleContext: ProShip_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'proship_home',
      type: ComponentType.form
    }
  }
}